(function () {
  'use strict';
  angular.module('vcconsult')
    .component('recentconsultlist', {
      restrict: 'E',
      bindings: {},
      template: `
        <div class="alert alert-info"  ng-show="vm.recentconsults.length === 0">Keine kürzlich geschlossenen Konsultationen</div>
        <div ng-repeat="rc in vm.recentconsults" ng-show="vm.recentconsults.length > 0">
          <a ui-sref="patientrecord.current({patientid: rc.patientid, clientid: rc.patientid, mode: 'patient'})">
            <span class="pull-left"><img class="img-responsive" style="max-width: 80px" ng-src="{{rc.patimage}}"></span>
            <h4  style="padding-left: 1em; margin-left: 1em">&nbsp;{{rc.patfirstname}} {{rc.patlastname}}<br>{{rc.patbdate}}</h4>
            <span class="clearfix"></span>
          </a>
        </div>
      `,
      controllerAs: 'vm',
      controller: ['$log', 'Consult', 'Rlog', 'vertxEventBusService',
        function ($log, Consult, Rlog, vertxEventBusService) {
          let vm = this;

          vm.$onInit = function () {
            const cutoff = moment().subtract(1, 'd');
            const comp = cutoff.toISOString();
            Consult.$search({open: false, active: true, created: {$gte: comp}}).$then(function (rc) {
              vm.recentconsults = rc;
            }, function (err) {
              $log.error('Loading list of recent consults failed: ', err);
              Rlog.error('vcconsult', 'recentconsultlist', 'Loading list of open consults failed', {});
            });
          }; // $onInit()


          const consultUpdateHandler = function (message) {
            if (angular.isDefined(vm.recentconsults) && angular.isDefined(vm.recentconsults.$refresh)) {
              vm.recentconsults.$refresh().$then(function () {
                $log.debug('Loading list of recently closed consults succeeded: ', message);
              }, function (err) {
                $log.error('Loading list of open consults failed: ', err);
                Rlog.error('vcconsult', 'recentconsultlist', 'refreshing list of recently closed consults failed', {});
              });
            }
          };

          // listen for consult updates
          vertxEventBusService.on('consults.update', {}, consultUpdateHandler);

          vm.$onDestroy = function () {
            vertxEventBusService.unregisterHandler('consults.update', {}, consultUpdateHandler);
          };

        }
      ] // controller

    }); // component

// klammerfriedhof
}());
